import { useEffect, useState } from "react";

const useDebounce = (text, delay = 700) => {
  const [debouncedText, setdebouncedText] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setdebouncedText(text);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay, text]);

  return debouncedText;
};

export default useDebounce;
